import * as postMessage from 'privates/postMessage';
import reporter from '../reporter';

function invokeApi(compId, compName, fn, ...fnArgs) {
    return new Promise((resolve, reject) => {
        postMessage.sendMessage(postMessage.Intent.WIX_CODE_APP_API, postMessage.MessageTypes.INVOKE_APP_FN, {
            compId,
            fn,
            fnArgs
        }, (data, error) => {
            if (error) {
                reject(`Failed to invoke ${fn} of component ${compName}`);
            } else {
                resolve(data);
            }
        });
    });
}

function registerToApiEvent(compId, compName, fn, cb, ...fnArgs) {
    postMessage.sendMessage(postMessage.Intent.WIX_CODE_APP_API, postMessage.MessageTypes.INVOKE_APP_ON, {
        compId,
        fn,
        fnArgs
    }, (data, error) => {
        if (error) {
            reporter.reportSdkError(`Failed to invoke ${fn} of component ${compName}`);
        } else {
            cb(data);
        }
    });
}

export default {
    invokeApi,
    registerToApiEvent
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/tpaUtils.es6